import { useMemo } from 'react'

import { Account } from '@modules-deprecated/app/accounts/types'
import { useAccountBankLines } from '@modules-deprecated/bankReconciliation/hooks/useAccountBankLines'

import { useFetchAccountStatements } from './useFetchAccountStatements'

const ACCOUNT_STATEMENT_PAGE_SIZE = 1

interface UseHasBookkeepingAccountDataProps {
  selectedBookkeepingAccount: Account | undefined
}

export const useHasBookkeepingAccountData = ({ selectedBookkeepingAccount }: UseHasBookkeepingAccountDataProps) => {
  const {
    bankLines,
    isError: hasBankLinesError,
    isLoading: isLoadingBankLines,
  } = useAccountBankLines({ accountId: selectedBookkeepingAccount?.id }, !!selectedBookkeepingAccount?.id)

  const {
    accountStatement,
    isError: hasAccountStatementError,
    isLoading: isLoadingAccountStatement,
  } = useFetchAccountStatements({
    accountId: selectedBookkeepingAccount?.id || '',
    pageSize: ACCOUNT_STATEMENT_PAGE_SIZE,
  })

  const bookkeepingAccountHasExistingBanklines = bankLines && bankLines.length > 0
  const bookkeepingAccountHasExistingPostings = accountStatement && accountStatement.rows.length > 0

  const bookkeepingAccountHasExistingData = useMemo(
    () => bookkeepingAccountHasExistingBanklines || bookkeepingAccountHasExistingPostings,
    [bookkeepingAccountHasExistingBanklines, bookkeepingAccountHasExistingPostings],
  )

  return {
    bookkeepingAccountHasExistingData,
    isError: hasBankLinesError || hasAccountStatementError,
    isLoading: isLoadingBankLines || isLoadingAccountStatement,
  }
}
